export default __webpack_public_path__ + "6a97f65.png";